module.exports = __webpack_public_path__ + "img/pexels-samfotograffo-3052362.299be8c2.jpg";